enum DiscountType {
  Points,
  PromoCode,
  SuperminsPoints
}

const { Points, PromoCode, SuperminsPoints } = DiscountType

namespace DiscountType {
  export const sortedMembers = [PromoCode, Points, SuperminsPoints]
}

export default DiscountType
